import React from 'react'
import * as THREE from 'three'
import useCameraAnimation from '../helper/UseCameraAnimation';

function CameraController({ selectedPlanet }) {
  const { animateToPosition } = useCameraAnimation();
  
  React.useEffect(() => {
    if (selectedPlanet) {
      const distance = selectedPlanet.distance;
      const targetPosition = new THREE.Vector3(
        distance + 3,
        2,
        distance + 3
      );
      const lookAtPosition = new THREE.Vector3(distance, 0, 0);
      
      animateToPosition(targetPosition, lookAtPosition);
    }
  }, [selectedPlanet, animateToPosition]);
  
  return null;
}
export default CameraController